export default {
  SET_SUBJECTS(state, array) {
    state.subjects = array;
  },
  SET_SUBJECT_PROFILES(state, array) {
    state.subject_profiles = array;
  },
  SET_CLASSGROUPS(state, array) {
    state.classgroups = array;
  },
};



// WEBPACK FOOTER //
// ./src/store/subjects/mutations.js